import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import CachedIcon from "@mui/icons-material/Cached";
import ApiEndpoints from "../network/ApiEndPoints";
import ApiPaginateSearch from "../component/ApiPaginateSearch";
import FilterCard from "../modals/FilterCard";
import { dateToTime, ddmmyy } from "../utils/DateUtils";
import { CustomStyles } from "../component/CustomStyle";

let refresh;
const ClosingBalance = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");

  const columns = [
    {
      name: "Created At",
      selector: (row) => (
        <div className="mb-1">
          {ddmmyy(row.created_at)}
          <br />
          {dateToTime(row.created_at)}
        </div>
      ),
    },
    {
      name: "User Id",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.user_id}
        </div>
      ),
    },
    {
      name: "Hold",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.hold}
        </div>
      ),
    },
    {
      name: "Username",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.username}
        </div>
      ),
    },
    {
      name: "Establishment",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.establishment}
        </div>
      ),
    },

    {
      name: "W1",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.w1}
        </div>
      ),
    },
    {
      name: "W2",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            wordBreak: "break-word", // Allows text to break and wrap
            overflowWrap: "break-word", // Ensures text wrapping
            whiteSpace: "normal",
            textAlign: "justify",
          }}
        >
          {row.w2}
        </div>
      ),
    },
    {
      name: "Closing Date",
      selector: (row) => <div className="mb-1">{ddmmyy(row.closing_date)}</div>,
    },
  ];

  function refreshFunc(setQuery) {
    setQuery("");
    if (refresh) refresh();
  }

  return (
    <Box>
      <Grid>
        <ApiPaginateSearch
          showSearch={false}
          isFilterAllowed={true}
          filterComponent={
            <>
              <FilterCard
                ifuseridFilter
                ifUsernameFilter
                setQuery={setQuery}
                query={query}
                clearHookCb={(cb) => {
                  refresh = cb;
                }}
                refresh={refresh}
                actionButtons={
                  <>
                    <Tooltip title="refresh">
                      <IconButton
                        aria-label="refresh"
                        // color="success"
                        sx={{
                          color: "#0F52BA",
                        }}
                        onClick={() => {
                          refreshFunc(setQuery);
                        }}
                      >
                        <CachedIcon className="refresh-purple" />
                      </IconButton>
                    </Tooltip>
                  </>
                }
              />
            </>
          }
          apiEnd={ApiEndpoints.GET_USER_CLOSING_BALANCE}
          columns={columns}
          apiData={apiData}
          setApiData={setApiData}
          tableStyle={CustomStyles}
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
        />
      </Grid>
    </Box>
  );
};

export default ClosingBalance;
